import { useSoftphone } from "@/contexts/SoftphoneContext";
import { useCallback } from "react";
import { toast } from "react-toastify";

/**
 * Click-to-call anywhere a phone number is displayed: places the call through
 * the softphone if the current user has an active line, otherwise falls back
 * to the browser/OS `tel:` handler.
 */
export function useClickToCall() {
  const { hasLine, call } = useSoftphone();

  const onCall = useCallback(
    (number: string) => {
      if (hasLine) {
        call(number).catch((error) => toast.error(error instanceof Error ? error.message : "Impossible de passer l’appel"));
      } else {
        document.location.href = `tel:${number}`;
      }
    },
    [hasLine, call]
  );

  return onCall;
}
